export const useSearchAllItemsStore = defineStore('searchAllItems', () => {
  const catalogApi = useCatalogAPI();
  const settingsStore = useSettingsStore();
 
  const allItemsRef = ref<MaterialItemApp[]>();

  async function fetchAllItems(request: SearchAllItemsRequest) {
    const includeWholesalerImages = settingsStore._settings.showWholesalerCatalogItemImages;
    const includeOwnImages = settingsStore._settings.showOwnItemImages;
    const allItemsResponse = await catalogApi.SearchAllItems(request, includeWholesalerImages, includeOwnImages);

    if (allItemsResponse && !allItemsResponse.HasErrors) {
      allItemsRef.value = allItemsResponse.Data;
    }
  }

  function reset() {
    allItemsRef.value = undefined;
  }

  const allItems= computed(() => allItemsRef.value ?? []);

  return {
    _allItemsRef: allItemsRef,
    allItemsRef: readonly(allItemsRef),
    fetchAllItems,
    reset,
    allItems
  };
});
